import { z } from 'zod';

// Basis: IPerson
export const personSchema = z.object({
  idPerson: z.number(),
  idGender: z.number(),
  idAcademicTitle: z.number(),
  FirstName: z.string(),
  LastName: z.string(),
  Surname: z.string().nullable(),
  Birthday: z.string(),
  Birthplace: z.string(),
  Street: z.string(),
  StreetNr: z.string(),
  StreetAditional: z.string().nullable(),
  idPostcode: z.number().nullable(),
  idCountry: z.number().nullable(),
  DateOfDeath: z.string().nullable(),
  PlaceOfDeath: z.string().nullable(),
  idBusinessForm: z.number().nullable(),

  // Kontaktinformationen
  Email: z.string().nullable(),
  PhoneNumber: z.string().nullable(),

  // Bankinformationen
  TaxNumber: z.string().nullable(),
  IBAN: z.string().nullable(),
  BIC: z.string().nullable(),
  Bank: z.string().nullable(),

  // Aus Relationen
  Postcode: z.string().optional(),
  City: z.string().optional(),
});

// Erweiterung: IInheritHasPerson
export const inheritHasPersonSchema = personSchema.extend({
  idInherit: z.number(),
  isStranger: z.boolean(),
});

// Erweiterung: IPurchaseContractHasPerson
export const purchaseContractHasPersonSchema = personSchema.extend({
  idPurchaseContractRelationType: z.number(),
});

export type IPerson = z.infer<typeof personSchema>;

export type IInheritHasPerson = z.infer<typeof inheritHasPersonSchema>;

export type IPurchaseContractHasPerson = z.infer<
  typeof purchaseContractHasPersonSchema
>;
